<template>
  <div class="product-media">
    <div v-if="error" class="product-media-error">
      <div class="error-message">
        Sorry, this content is unavailable. Please try again later.
      </div>
    </div>
    <div v-else class="product-media-panel" :class="'list-column-' + list.length">
      <div class="product-media-list">
        <a 
          class="product-media-list-item"
          v-for="(item, index) in list" :key="index" 
          :href="item.id | productUrl(that)" 
          target="_blank"
          @click="onClickProductCard">
            <div class="header">
              <div class="city-icon"><img src="../../assets/icons/promotion/ic_location_fill.svg" />{{item.countries | locationStr}}</div>
              <div class="discount" v-if="item.discount > 0">{{ item.discount | discount }}% OFF</div>
              <div class="picture-img"><img :src="item.img_url" /></div>
            </div>
            <div class="body">
              <div class="content">
                <div class="name">
                  {{item.name}}
                </div>
                <div class="comment">
                  <img class="star-icon" :class="{'disappear':item.rating_star == 0}" src="../../assets/icons/promotion/ic_star_fill.svg" />
                  <div class="comment-num" :class="{'disappear':item.rating_star == 0}">{{ item.rating_star | decimal }}({{ item.rating_count | thousandSeparator }})</div>
                  <img class="line-icon" :class="{'disappear':item.rating_star == 0 || item.show_order_count==''}" src="../../assets/icons/promotion/line.svg"/>
                  <div class="order-num" :class="{'disappear':item.show_order_count==''}">{{item.show_order_count}} {{langList[language].booked}}</div>
                </div>
              </div>
              <div class="price">
                <div class="original" :class="{'hidden':item.sale_price == item.price}">{{item.currency}} {{item.display_sale_price}}</div>
                <div class="current">
                  <div class="currency">{{item.currency}}</div>
                  <div class="current-price">{{item.display_price}}</div>
                  <div class="rise">{{langList[language].from}}</div>
                </div>
              </div>
            </div>
        </a>
      </div>
      <template v-if="productMedia">
        <div class="product-media-more">
          <a :href="productMedia | seeMoreUrl(that)" target="_blank" class="k-subtitle-md" @click="onClickSeeMore">{{langList[language].seeMore}}</a>
        </div>
        <div class="product-media-copyright">
          <div class="line">
            {{langList[language].copyright1}}
          </div>
          <div class="line">
            {{langList[language].copyright2}}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { searchProduct } from '@/api/affiliate'
  import { getLocationStr, param } from '@/utils/tool'
  import { mixpanelTrack } from '@/libs/mixpanel'
  
  export default {
    data() {
      return {
        that: this, // 提供给filters传递this使用
        list: [], // 商品卡
        productMedia: null, // productMedia配置
        error: false,
        language: 'zh-tw',
        langList: {
          'zh-tw': {
            booked: '個已訂購',
            from: '起',
            seeMore: '查看更多',
            copyright1: '實際商品資訊依 KKday 網站顯示為準',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          },
          "zh-hk": {
            booked: '個已訂購',
            from: '起',
            seeMore: '查看更多',
            copyright1: '實際商品資訊依 KKday 網站顯示為準',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          },
          "zh-cn": {
            booked: '个已订购',
            from: '起',
            seeMore: '查看更多',
            copyright1: '实际商品资讯依 KKday 网站显示为准',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          },
          "en": {
            booked: 'booked',
            from: 'from',
            seeMore: 'See more',
            copyright1: 'The actual product content on the KKday website shall be final',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          },
          "ja": {
            booked: '件ご利用',
            from: '~',
            seeMore: 'もっと見る',
            copyright1: '正確な商品情報はKKdayサイトの表示内容に準じます。',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          },
          "ko": {
            booked: '예약',
            from: '부터',
            seeMore: '더 보기',
            copyright1: '실제 상품 정보는 KKday 웹사이트를 기준으로 합니다.',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          },
          "vi": {
            booked: 'đã đặt',
            from: 'từ',
            seeMore: 'Khám phá thêm',
            copyright1: 'Nội dung sản phẩm thực tế trên trang web KKday sẽ là nội dung cuối cùng',
            copyright2: 'BẢN QUYỀN © KKday Mọi quyền được bảo lưu.'
          },
          "th": {
            booked: 'จองแล้ว',
            from: 'ราคาเริ่มต้น',
            seeMore: 'ดูเพิ่มเติม',
            copyright1: 'เนื้อหาผลิตภัณฑ์บนเว็บไซต์ของ KKday ถือเป็นที่สุด',
            copyright2: 'COPYRIGHT © KKday ขอสงวนลิขสิทธิ์'
          },
          "default": {
            booked: 'booked',
            from: 'from',
            seeMore: 'See more',
            copyright1: 'The actual product content on the KKday website shall be final',
            copyright2: 'COPYRIGHT © KKday All rights reserved.'
          }
        }
      }
    },
    filters: {
      // 查看商品详情
      productUrl(val, that){
        let obj = {
          cid: that.productMedia.cid
        }
        Object.keys(that.productMedia.ud).forEach(key => {
          if(that.productMedia.ud[key]){
            obj[key] = that.productMedia.ud[key]
          }
        })
        let hostname = 'www.kkday.com'
        if(['sit', 'local'].includes(process.env.VUE_APP_ENV)) {
          hostname = 'www.sit.kkday.com'
        } else if(process.env.VUE_APP_ENV == 'stage') {
          hostname = 'www.stage.kkday.com'
        } else {
          hostname = 'www.kkday.com'
        }
        return `https://${hostname}/${that.language}/product/${val}?${param(obj)}`
      },
      // 地区字符串，最多俩节
      locationStr(val){
        return getLocationStr(val, 2)
      },
      // 折扣%，向上取整
      discount(val){
        return Math.ceil(val * 100)
      },
      // 保留一位小数，向下取整
      decimal(val){
        return Math.floor(val * 10) / 10
      },
      // 千分位分隔
      thousandSeparator(val){
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      // 查看更多按钮
      seeMoreUrl(val, that){
        let obj = {
          cid: that.productMedia.cid
        }
        Object.keys(that.productMedia.ud).forEach(key => {
          if(that.productMedia.ud[key]){
            obj[key] = that.productMedia.ud[key]
          }
        })
        let hostname = 'www.kkday.com'
        if(['sit', 'local'].includes(process.env.VUE_APP_ENV)) {
          hostname = 'www.sit.kkday.com'
        } else if(process.env.VUE_APP_ENV == 'stage') {
          hostname = 'www.stage.kkday.com'
        } else {
          hostname = 'www.kkday.com'
        }
        // city调整为destination
        if(that.productMedia.destination && that.productMedia.destination.length == 1) {
          // 单一城市推荐时，跳转City Page
          return `https://${hostname}/${that.language}/destination/${that.productMedia.destination[0].url_name}?${param(obj)}`
        } else {
          return `https://${hostname}/${that.language}?${param(obj)}`
        }
      }
    },
    created() {
      this.initPage()
    },
    methods: {
      async initPage(){
        let isMaintenance = localStorage.getItem('isMaintenance')
        if(isMaintenance == 'true'){
          this.error = true
          return
        }
        if(this.$route.query.oid) {
          let res = await searchProduct({
            method: 'oid',
            product_media_oid: this.$route.query.oid
          })
          if(res?.metadata?.status === '0000'){
            this.productMedia = res.data.product_media
            // 获取语系
            this.language = this.langList[this.productMedia.lang_code] ? this.productMedia.lang_code : 'default'
            this.productMedia.ud.ud3 = "prodcard"
            if(this.productMedia.search_type == 'MANUAL') {
              this.productMedia.ud.ud4 = "manual"
              // 商品结果与手动输入的product_mid一一对应，对应不上的不显示
              let list = []
              this.productMedia.product_mid.forEach(mid => {
                let item = res.data.product_list.find(e => e.id == mid)
                if(item) list.push(item)
              })
              this.list = list
            } else {
              this.productMedia.ud.ud4 = "recommend"
              this.list = this.duplicateCards(res.data.product_list, this.productMedia.product_number)
            }
            mixpanelTrack('ProdMedia_External_Viewed',{
              AD_CID: this.productMedia.cid,
              AD_Refer_URL: this.$route.query.refer
            })
          } else {
            this.error = true
          }
        }
      },
      duplicateCards(product_list, num){
        let list = Array.from(product_list)
        if(list.length == 0) {
          // 商品无法铺满时，不显示
          return []
        } else if(list.length < num) {
          // 重复卡片直至铺满为止
          while(list.length < num){
            list = list.concat(list)
          }
          return list.slice(0, num)
        } else {
          return list
        }
      },
      onClickProductCard(){
        mixpanelTrack('ProdMedia_ProductCard_Clicked',{
          AD_CID: this.productMedia.cid,
          AD_Refer_URL: this.$route.query.refer
        })
      },
      onClickSeeMore(){
        mixpanelTrack('ProdMedia_Seemore_Clicked',{
          AD_CID: this.productMedia.cid,
          AD_Refer_URL: this.$route.query.refer
        })
      }
    }
  }
</script>
<style lang="less">
  html, body{
    background: transparent;
  }
</style>
<style lang="less" scoped>
  .product-media {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    
    a{
      text-decoration: none;
    }
    
    .disappear{
      display: none;
    }
    
    .hidden{
      visibility: hidden;
    }
    
    .product-media-error{
      width: 100%;
      min-height: 100vh;
      // padding: 0 32px;
      background: #F1F4F8;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
     
      .error-message{
        padding: var(--kk--spacing-8, 32px);
        color: #727272;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; 
      }
    }
    .product-media-panel{
      display: flex;
      margin: 0 auto;
      padding: var(--kk--spacing-8, 32px) var(--kk--spacing-3, 8px);
      flex-direction: column;
      align-items: center;
      gap: var(--kk--spacing-7, 24px);
      
      &.list-column-6,&.list-column-3{
        width: 704px;
      }
      
      &.list-column-4{
        width: 944px;
      }
      .product-media-list {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: var(--kk--spacing-7, 24px) var(--kk--spacing-5, 16px);

        .product-media-list-item {
          width: 224px;
          height: 284px;
          border-radius: var(--kk--radius-lg, 12px);
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.10);
          overflow: hidden;
          background: var(--kk--white-fff, #FFF);

          &:hover {
            opacity: .8;
          }

          .header {
            position: relative;
            width: 100%;
            height: 124px;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 21.35%), linear-gradient(180deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 18.69%);
            
            .city-icon {
              position: absolute;
              top: 10px;
              left: 8px;
              color: #FFF;
              font-family: "PingFang TC";
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px;
              display: flex;
              align-items: center;
              z-index: 2;

              img {
                width: 14px;
                height: 14px;
              }
            }

            .discount {
              position: absolute;
              bottom: 0;
              left: 0;
              display: flex;
              padding: 0px var(--kk--spacing-3, 8px);
              justify-content: center;
              align-items: center;
              color: #FFF;
              font-family: "PingFang HK";
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 20px;
              border-top-right-radius: 6px;
              background: linear-gradient(311deg, #FFD56E 8.64%, #FFAF1E 94.27%);
            }

            .picture-img {
              width: 100%;
              height: 100%;
              overflow: hidden;
              background-color: #eaeaea;
              
              &:before {
                  background-image: -webkit-gradient(linear,left bottom,left top,from(transparent),color-stop(rgba(0,0,0,.2)),to(rgba(0,0,0,.4)));
                  background-image: linear-gradient(0deg,transparent,rgba(0,0,0,.2),rgba(0,0,0,.4));
                  content: "";
                  height: 25%;
                  left: 0;
                  position: absolute;
                  top: 0;
                  width: 100%;
                  z-index: 1;
              }
              
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
          .body{
            display: flex;
            padding: var(--kk--spacing-4, 12px);
            flex-direction: column;
            align-items: flex-start;
            gap: var(--kk--spacing-3, 8px);
            align-self: stretch;
            
            .content{
              height: 96px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: var(--kk--spacing-2, 4px);
              align-self: stretch;
              text-align: left;
              color: #212121;
              
              .name{
                width: 100%;
                max-height: 72px;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; 
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .comment{
                display: flex;
                align-items: center;
                color: #666;
                white-space: nowrap;
                
                .star-icon{
                  width: 16px;
                  height: 16px;
                }
                .comment-num{
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 20px; 
                }
                .line-icon{
                  width: 2px;
                  height: 16px;
                  margin: 0 var(--kk--spacing-2, 4px);
                }
                .order-num{
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 20px; 
                }
              }
            }
            
            .price{
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              gap: var(--kk--spacing-1, 2px);
              
              .original{
                color: #9C9DA0;
                font-family: "Helvetica Neue";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 14px;
                text-decoration-line: line-through;
              }
              .current{
                display: flex;
                align-items: center;
                align-content: center;
                gap: 4px var(--kk--spacing-2, 4px);
                align-self: stretch;
                flex-wrap: wrap;
                color: #212121;
                .currency{
                  font-family: "Helvetica Neue";
                  font-size: 16px;
                  font-weight: 700;
                  line-height: 16px;
                }
                .current-price{
                  font-family: "Helvetica Neue";
                  font-size: 16px;
                  font-weight: 700;
                  line-height: 16px;
                }
                .rise{
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 14px;
                }
              }
            }
          }
        }
      }
      .product-media-more{
        a{
          display: flex;
          padding: var(--kk--spacing-4, 12px) var(--kk--spacing-7, 24px);
          justify-content: center;
          align-items: center;
          gap: var(--kk--spacing-2, 4px);
          color: var(--kk--white-fff, #FFF);
          text-align: center;
          font-family: "PingFang TC";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; 
          border-radius: var(--radius-md, 8px);
          background: #1AB6C1;
        }
      }
      .product-media-copyright{
        color: var(--kk--text-icon-color-text-dark, #727272);
        text-align: center;
        /* Body-md */
        font-family: "PingFang TC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; 
      }
    }
  }
  
  //适配样式：screen <= 959px
  @media screen and (max-width:959px){
      .product-media .product-media-panel.list-column-4{
        width: 544px;
      }
  }
  @media screen and (max-width:719px){
      .product-media .product-media-panel.list-column-6{
        width: 544px;
      }
      .product-media .product-media-panel.list-column-3{
        width: 375px;
        .product-media-list-item{
          width: 336px;
          height: 333px;
          .header{
            height: 189px;
          }
          .body .content{
            height: 76px;
            .name{
              max-height: 52px;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
  }
  @media screen and (max-width:495px){
      .product-media .product-media-panel.list-column-6,
      .product-media .product-media-panel.list-column-4{
         width: 375px;
        .product-media-list-item{
          width: 336px;
          height: 333px;
          .header{
            height: 189px;
          }
          .body .content{
            height: 76px;
            .name{
              max-height: 52px;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
  }
</style>
